import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { PaymentformComponent } from "./paymentform/paymentform.component";

const routes: Routes = [
  {
    path: '',
    component: PaymentformComponent,
  }
]


@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PaymentRoutingModule { }